/**
 * Resolves the default locale for the given host name based on the brand's domain → locale map
 * in runtime config. Looks up the host's TLD first, then any registered TLD that the host ends
 * with, and falls back to the runtime-config `defaultLocale` when no domain matches or `host` is
 * missing.
 * @param host - The request host (e.g. `'shop.timberland.eu'`); typically read from request headers.
 * @returns The locale code to use for this host.
 * @category Utils
 */
export const getLocaleFromDomain = (host?: string) => {
  const { defaultLocale, domains } = useRuntimeConfig().public.i18n
  if (!domains || !host) return defaultLocale

  const lastDomainSegment = host.substring(host.lastIndexOf('.'))
  const domain = domains[lastDomainSegment]
    || domains[Object.keys(domains).find((domainTld) => host.endsWith(domainTld)) || '']
  return domain?.defaultLocale || defaultLocale
}
